import { TChatRoom } from "./chatType";

const getInitials = (name?: string) => {
  if (!name) return "??";
  const parts = name.trim().split(/\s+/);
  return (parts[0]?.[0] ?? "?") + (parts[1]?.[0] ?? "");
};

export const mapRoomsToConversations = (
  rooms: TChatRoom[],
  myUserId: string,
  myRole: "client" | "creator",
): TChatRoom[] => {
  return rooms.map((room) => {
    const otherUser = myRole === "client" ? room.creator_id : room.client_id;

    // --- Last message ---
    const lastMessage = room.last_message?.content || "No messages yet";
    const timestamp = room.last_message?.timestamp || room.updatedAt;

    // --- Name + avatar logic ---
    const otherName =
      (otherUser as any)?.fullName ||
      (otherUser as any)?.name ||
      "Unknown user";

    const otherAvatar =
      (otherUser as any)?.profileImage || (otherUser as any)?.avatarUrl || null;

    if (room.chat_type === "order_video") {
      const projectName = room.order_meta?.projectName || "Order chat";
      const videoTitle =
        room.video_meta?.title ||
        (room.video_meta?.video_id
          ? `Video-${room.video_meta.video_id}`
          : "") ||
        "";

      // Title that clearly indicates "order thread"
      const title = videoTitle ? `${projectName} • ${videoTitle}` : projectName;

      return {
        ...room,
        name: title,
        // If you want order rooms to still show a person avatar, keep otherAvatar.
        // If you want a generic "order" avatar, set avatar to null and let UI show a badge/icon.
        avatar: otherAvatar,
        lastMessage,
        timestamp,
        unreadCount: 0,
        isOnline: true,
        // Optional: if your UI supports a subtitle
        // subtitle: otherName,
        // fallbackInitials: getInitials(otherName),
      };
    }

    // default: direct chat
    return {
      ...room,
      name: otherName,
      avatar: otherAvatar,
      lastMessage,
      timestamp,
      unreadCount: 0,
      isOnline: true,
      // fallbackInitials: getInitials(otherName),
    };
  });
};
